import { 
  signInWithPopup, 
  GoogleAuthProvider, 
  signOut as firebaseSignOut,
  onAuthStateChanged,
  getAuth
} from 'firebase/auth';
import { auth, db } from './firebase';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

// Proveedor de Google
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Servicio de autenticación
export const authService = {
  // Iniciar sesión con Google
  signInWithGoogle: async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      // Verificar dominio de Cromodata
      if (!user.email.endsWith('@cromodata.com')) {
        await firebaseSignOut(auth);
        throw new Error('Solo se permiten cuentas @cromodata.com');
      }
      
      // Asegurar documento de usuario con rol en Firestore (necesario para las reglas)
      try {
        await setDoc(
          doc(db, 'users', user.uid),
          {
            uid: user.uid,
            email: user.email,
            name: user.displayName || user.email.split('@')[0],
            photoURL: user.photoURL || null,
            role: 'admin',
            updatedAt: serverTimestamp(),
            // createdAt se setea solo la primera vez; merge true evita sobreescribirlo si ya existe
            createdAt: serverTimestamp()
          },
          { merge: true }
        );
      } catch (e) {
        // No bloquear login por esto; se verá reflejado al intentar escribir
        // y el usuario podrá reintentar
        console.warn('No se pudo asegurar el doc de usuario:', e);
      }

      // Crear objeto de usuario personalizado
      const customUser = {
        uid: user.uid,
        email: user.email,
        name: user.displayName || user.email.split('@')[0],
        photoURL: user.photoURL,
        role: 'admin', // Por defecto admin, puedes cambiar esto según tu lógica
        createdAt: new Date().toISOString()
      };
      
      return customUser;
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      throw error;
    }
  },

  // Cerrar sesión
  signOut: async () => {
    try {
      await firebaseSignOut(auth);
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      throw error;
    }
  },

  // Obtener usuario actual
  getCurrentUser: () => {
    return auth.currentUser;
  },

  // Escuchar cambios en el estado de autenticación
  onAuthStateChanged: (callback) => {
    return onAuthStateChanged(auth, async (user) => {
      if (user && user.email && user.email.endsWith('@cromodata.com')) {
        // Asegurar doc de usuario también en reentradas/sesión persistida
        try {
          await setDoc(
            doc(db, 'users', user.uid),
            {
              uid: user.uid,
              email: user.email,
              name: user.displayName || user.email.split('@')[0],
              photoURL: user.photoURL || null,
              role: 'admin',
              updatedAt: serverTimestamp(),
            },
            { merge: true }
          );
        } catch (e) {
          console.warn('No se pudo asegurar el doc de usuario (state change):', e);
        }
      }
      callback(user);
    });
  },

  // Verificar si el usuario está autenticado
  isAuthenticated: () => {
    return !!auth.currentUser;
  },

  // Verificar si el usuario tiene dominio de Cromodata
  isCromodataUser: (user) => {
    return user && user.email && user.email.endsWith('@cromodata.com');
  }
};

export default authService;
